if (!customElements.get('snoop-bundle')) {
  customElements.define('snoop-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.choices = new Set();
      this.tiers = [...this.querySelectorAll('.simple-variant-picker__value-container')];
      const template = this.querySelector('[data-snoop-extras]');
      this.tiers.forEach((tier, index) => {
        tier.classList.add('snoop-tier');
        if (template) tier.append(template.content.cloneNode(true));
        const badge = this.querySelector(index === 1 ? '[data-snoop-badge-two]' : index === 2 ? '[data-snoop-badge-three]' : '[data-no-badge]');
        if (badge) tier.append(badge.content.cloneNode(true));
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-snoop-addon]')) {
          event.stopPropagation();
          const key = event.target.dataset.snoopAddon;
          event.target.checked ? this.choices.add(key) : this.choices.delete(key);
          this.querySelectorAll(`[data-snoop-addon="${key}"]`).forEach(input => { input.checked = event.target.checked; });
        }
        this.updateTotal();
        requestAnimationFrame(() => this.updateTotal());
      }, { signal: this.abort.signal });
      this.bindForm = () => {
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;
        this.button = this.form.querySelector('.button-text');
        this.submit = this.form.querySelector('[type="submit"]');
        this.buttonPrefix = this.submit?.dataset.persistentText || this.button?.textContent.split(' - ')[0].trim() || '';
        this.form.addEventListener('formdata', event => this.addExtras(event.formData), { signal: this.abort.signal });
        if (this.button) {
          this.observer = new MutationObserver(() => this.updateTotal());
          this.observer.observe(this.button, { childList: true, subtree: true, characterData: true });
        }
        this.updateTotal();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.bindForm, { once:true, signal:this.abort.signal });
      else this.bindForm();
    }
    selectedTier() { return this.tiers.find(tier => tier.querySelector('.simple-variant-picker__radio')?.checked); }
    selectedExtras() { return [...(this.selectedTier()?.querySelectorAll('[data-snoop-addon]:checked:not(:disabled)') || [])]; }
    updateTotal() {
      if (!this.button || !this.submit || this.submit.classList.contains('sold-out')) return;
      if (this.submit.dataset.showPrice !== 'true') {
        if (this.button.textContent !== this.buttonPrefix) this.button.textContent = this.buttonPrefix;
        return;
      }
      const tier = this.selectedTier();
      const base = Number(tier?.querySelector('.simple-variant-picker__list-price')?.dataset.price);
      if (!Number.isFinite(base)) return;
      const quantity = Number(this.form?.querySelector('[name="quantity"]')?.value || 1);
      const total = base * quantity + this.selectedExtras().reduce((sum, input) => sum + Number(input.dataset.price), 0);
      const money = new Intl.NumberFormat(this.dataset.locale || 'en', { style:'currency', currency:this.dataset.currency || 'USD' }).format(total / 100);
      const text = `${this.buttonPrefix} - ${money}`;
      if (this.button.textContent !== text) this.button.textContent = text;
    }
    addExtras(data) {
      const extras = this.selectedExtras();
      if (!extras.length || !data.get('id') || data.has('items[0][id]')) return;
      data.set('items[0][id]', data.get('id'));
      data.set('items[0][quantity]', data.get('quantity') || '1');
      if (data.get('selling_plan')) data.set('items[0][selling_plan]', data.get('selling_plan'));
      for (const [key,value] of [...data.entries()]) {
        if (key.startsWith('properties[')) { data.set(`items[0][properties]${key.slice(10)}`, value); data.delete(key); }
      }
      data.delete('id'); data.delete('quantity'); data.delete('selling_plan');
      extras.forEach((input,index) => {
        data.set(`items[${index+1}][id]`, input.dataset.variantId);
        data.set(`items[${index+1}][quantity]`, '1');
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
